export default class Lists {
  static db = ["Flutter", "Figma"];
  static bf = ["Flutter", "Figma"];
  static nda = ["Flutter", "Figma"];
  static arm = ["Flutter", "Figma"];
  static asp = ["Flutter", "Figma"];
  static hp = ["Flutter", "Firebase"];
  static mnm = ["Flutter", "Firebase"];
  static payclix = ["Flutter", "Figma"];
  static souqcards = ["Flutter", "Neumorphic"];
  static cm = ["Flutter", "In App Purchase"];
  static miko = ["Flutter", "ChargeBee", "Airship"];
}
